<template>
  <v-dialog v-model="dialog" max-width="900px">
    <v-card class="perfiles">
      <v-card-title>
        <span class="text-h5">{{ $t("view.seguridad.usuariosPerfiles.titulo.label") }}</span>
        <v-spacer />
        <v-text-field v-model="view.elem.datatable.search" append-icon="mdi-magnify" :label="$t('view.commons.search')" single-line dense hide-details class="mr-8" @change="load" />
        <v-btn fab small color="primary" class="btn_tippy" elevation="0" :title="$t('view.commons.close')" @click="dialog = false">
          <v-icon small>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-subtitle class="hidden-sm-and-down">{{ usuario }}</v-card-subtitle>
      <v-card-text>
        <v-layout row wrap class="mx-0 my-0">
          <v-flex xs12 class="overflow">
            <v-data-table
              ref="dataTable"
              item-key="permiso"
              class="perfiles dataTable"
              sort-by="check"
              :sort-desc.sync="view.elem.datatable.sortdesc"
              :headers="view.elem.datatable.headers"
              :items="view.elem.datatable.data"
              :search="view.elem.datatable.search"
              :must-sort="true"
              :items-per-page="-1"
              :options.sync="options"
              hide-default-footer>
              <template #item.check="{ item }">
                <v-btn
                  :disabled="!$userPermission.hasPermission('ROLE_MODIFICAR_SEGURIDAD')"
                  fab
                  dark
                  x-small
                  elevation="0"
                  style="width: 25px; height: 25px"
                  :loading="item.busy"
                  :color="item.check ? 'primary' : 'green'"
                  :title="item.check ? $t('view.commons.remove') : $t('view.commons.add')"
                  class="btn_tippy"
                  @click="perfilAddOrRemove(item)">
                  <v-icon>{{ item.check ? "clear" : "add" }}</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import UsuarioAPI from "@/services/seguridad/usuario"; /** *******************************/
import { handleResponse } from "@/helpers/http-response-handler";
import tippy from "tippy.js";

export default {
  name: "PerfilesModal"
  , data() {
    return {
      dialog: false
      , perfiles: []
      , usuario: ""
      , options: {}
      , view: {
        action: { submit: { busy: false } }
        , elem: {
          datatable: {
            data: []
            , search: ""
            , sortdesc: true
            , headers: [
              { text: this.$t("view.seguridad.usuariosPerfiles.perfil.th"), align: "left", sortable: true, class: "nombre", value: "nombre" }
              , { text: this.$t("view.commons.accion"), align: "center", sortable: true, class: "accion", value: "check" }
            ]
          }
        }
      }
    };
  }
  , watch: {
    options: {
      handler() {
        this.load();
      }
      , deep: true
    }
  }
  , updated() {
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , methods: {
    async load() {
      this.view.elem.datatable.data = this.perfiles;
      this.view.elem.datatable.total = Number(this.perfiles.length);
    }
    , async loadPerfiles(username, nombre) {
      const respuesta = await UsuarioAPI.getPerfiles({ username });
      this.perfiles = respuesta.data.results.perfilesUsuario;
      this.view.elem.datatable.search = "";
      this.view.elem.datatable.sortdesc = true;
      this.perfiles.forEach((item) => {
        this.$set(item, "busy", false);
      });
      this.usuario = `Usuario: ${nombre}`;
      this.dialog = true;
      this.load();
    }
    , async perfilAddOrRemove(perfil) {
      let response;
      perfil.busy = true;
      if (perfil.check) {
        response = await UsuarioAPI.removePerfil(perfil);
      } else {
        response = await UsuarioAPI.addPerfil(perfil);
      }
      if (handleResponse(response, this.$t("view.seguridad.usuariosPerfiles.errors"))) {
        perfil.check = !perfil.check;
      }
      setTimeout(() => {
        perfil.busy = false;
      }, 200);
    }
  }
};
</script>

<style>
.perfiles .overflow {
  overflow-y: auto;
  max-height: 600px;
}
@media (max-height: 850px) {
  .perfiles .overflow {
    max-height: 400px !important;
  }
}
@media (max-height: 650px) {
  .perfiles .overflow {
    max-height: 300px !important;
  }
}
@media (max-height: 510px) {
  .perfiles .overflow {
    max-height: auto;
    overflow-y: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/seguridad/usuario/PerfilesModal.vue